<app-popup>
  <div trigger class="trigger" [class.active]="isActive()">{{ item()?.name }}</div>
  @if (isActive()) {
    <div content>
      @for (formatItem of item()?.formats; track formatItem.name) {
        <div class="item">
          <div>
            {{ formatItem.name }}
            @if (formatItem.unit) {
              <div i18n class="unit">File format: {{ formatItem.unit }}</div>
            }
          </div>
          <div class="download" (click)="format.emit(formatItem.to)" (keyup)="format.emit(formatItem.to)" tabindex="0">
            <app-icon icon="download" />
            <span i18n>Download</span>
          </div>
        </div>
      }
    </div>
  }
</app-popup>
